import { use, useEffect } from 'react';
import ErrorMessageProviderContext from 'shared/components/error/providers/contexts/error-message-context';

import { useReadScenarios } from 'features/scenario/domain/queries/scenarios-queries';
import Scenario from 'features/scenario/models/scenario';

interface ScenarioHook {
  scenarios?: Scenario[];
  isLoading: boolean;
  isSuccess: boolean;
}

const useScenario = (): ScenarioHook => {
  const { setErrorMessage } = use(ErrorMessageProviderContext);
  const { data: readScenariosResponse, isSuccess, isLoading, error } = useReadScenarios();

  useEffect(() => {
    if (error) {
      setErrorMessage(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return {
    scenarios: readScenariosResponse?.scenarios,
    isLoading,
    isSuccess,
  };
};

export default useScenario;
